var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Create new phase line",
        description: "Specify the details of your new phase line.",
        label: "Create",
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onCreate
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-4 px-8" },
        [
          _c(
            "div",
            { staticClass: "flex gap-4" },
            [
              _c("BlInputText", {
                attrs: { input: _vm.labelInput },
                on: { changed: _vm.inputHandler }
              }),
              _vm._v(" "),
              !_vm.isPrompting
                ? _c("div", { staticClass: "relative" }, [
                    _c(
                      "label",
                      { staticClass: "mb-1 relative" },
                      [_c("BlTextBody3", { attrs: { text: "Color" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "relative h-10 w-24 px-4 flex items-center justify-between border rounded cursor-pointer",
                        class: _vm.colorOpened
                          ? "border-light-purple "
                          : "border-grey-200 ",
                        attrs: { "data-id": "phase-line-color" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.colorOpened = !_vm.colorOpened
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "w-6 h-6 flex-shrink-0 rounded-full",
                          style: {
                            backgroundColor: _vm.phaseLineColors[_vm.colorInput]
                          }
                        }),
                        _vm._v(" "),
                        _c("BlIcon", {
                          staticClass:
                            "absolute right-4 w-5 h-5 transition-all duration-300",
                          style: _vm.colorOpened ? "rotate: 180deg" : "",
                          attrs: {
                            "data-id": "phase-line-color",
                            icon: "chevron-down"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.colorOpened
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "absolute right-0 w-38 max-h-48 mt-2 z-10 py-4 pl-4 bg-pure-white rounded border border-grey-200 shadow-md",
                            attrs: { "data-id": "phase-line-color" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { "data-id": "phase-line-color" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex flex-wrap gap-2",
                                    attrs: { "data-id": "phase-line-color" }
                                  },
                                  _vm._l(
                                    Object.keys(_vm.phaseLineColors),
                                    function(color) {
                                      return _c("button", {
                                        key: color,
                                        staticClass:
                                          "h-6 w-6 flex-shrink-0 rounded border-2 outline-none",
                                        class:
                                          color === _vm.colorInput
                                            ? "border-light-purple"
                                            : "border-transparent",
                                        style: {
                                          backgroundColor:
                                            _vm.phaseLineColors[color]
                                        },
                                        attrs: { title: color },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.colorInput = color
                                          }
                                        }
                                      })
                                    }
                                  ),
                                  0
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("BlInputText", {
            attrs: { input: _vm.descriptionInput },
            on: { changed: _vm.inputHandler }
          }),
          _vm._v(" "),
          !_vm.hasPhaseLine
            ? _c(
                "div",
                {
                  staticClass:
                    "w-156 p-2 bg-info-100 text-info rounded flex items-center gap-2 text-sm"
                },
                [
                  _c("BlIcon", {
                    staticClass: "flex-shrink-0 w-6",
                    attrs: { icon: "toast-info" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody1", {
                    attrs: {
                      text:
                        "Creating a phase line for the first time? We'll set up a baseline for you that you can edit later."
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb5456d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb5456d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/NewPhaseLineModal.vue
// module id = null
// module chunks = 